import { Dialog, DialogBody, DialogContent, DialogTrigger, TextLink } from '@civilgrid/ui/components';
import { cn } from '@civilgrid/ui/utils';
import type { AsyncState } from 'react-use/lib/useAsyncFn';
import type { GetCostOutput } from '~/common/billingUtils';
import CostBreakdown from './CostBreakdown';
import ProjectPricingTable from './ProjectPricingTable';

type ProjectTypeInfoDialogProps = {
  projectCost: AsyncState<GetCostOutput>;
  /** Prefixes every test id, e.g. `new-project` → `new-project-compare-project-types`. */
  testIdPrefix: string;
  /** Width classes for the dialog content. */
  className?: string;
};

export function CompareProjectTypesDialog({ projectCost, testIdPrefix, className }: ProjectTypeInfoDialogProps) {
  const testId = `${testIdPrefix}-compare-project-types`;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <TextLink className="underline" data-testid={testId}>
          Compare project types
        </TextLink>
      </DialogTrigger>
      <DialogContent
        title="Compare project types"
        titleProps={{ className: 'text-lg font-normal' }}
        headerProps={{ className: 'px-8 pt-8 pb-2' }}
        className={cn('max-w-6xl', className)}
        data-testid={`${testId}-dialog`}
      >
        <DialogBody className="px-8 pt-0 pb-8">
          <ProjectPricingTable projectCost={projectCost} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function CostBreakdownDialog({ projectCost, testIdPrefix, className }: ProjectTypeInfoDialogProps) {
  const testId = `${testIdPrefix}-view-cost-breakdown`;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <TextLink className="underline" data-testid={testId}>
          View cost breakdown
        </TextLink>
      </DialogTrigger>
      <DialogContent
        title="Cost Breakdown"
        titleProps={{ className: 'text-lg font-normal' }}
        headerProps={{ className: 'px-8 pt-8 pb-2' }}
        className={className}
        data-testid={`${testId}-dialog`}
      >
        <DialogBody className="px-8 pt-0 pb-8">
          <CostBreakdown projectCost={projectCost} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
